import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ProjectGrid } from '../components/ProjectGrid';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-252">
      <Navigation data-id="element-253" />
      <main data-id="element-254">
        <Hero data-id="element-255" />
        <ProjectGrid data-id="element-256" />

        {/* Services Teaser */}
        <section className="py-24 px-6 border-t border-white/10" data-id="element-257">
          <div className="max-w-7xl mx-auto" data-id="element-258">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-259">
              <div className="p-8 border border-white/10 hover:border-yellow-400 transition-colors group" data-id="element-260">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-yellow-400 transition-colors" data-id="element-261">
                  Branding
                </h3>
                <p className="text-gray-400" data-id="element-262">
                  Visual identity, strategy, and guidelines for modern brands.
                </p>
              </div>
              <div className="p-8 border border-white/10 hover:border-yellow-400 transition-colors group" data-id="element-263">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-yellow-400 transition-colors" data-id="element-264">
                  Digital
                </h3>
                <p className="text-gray-400" data-id="element-265">
                  Web design, development, and interactive experiences.
                </p>
              </div>
              <div className="p-8 border border-white/10 hover:border-yellow-400 transition-colors group" data-id="element-266">
                <h3 className="text-2xl font-bold mb-4 group-hover:text-yellow-400 transition-colors" data-id="element-267">
                  Content
                </h3>
                <p className="text-gray-400" data-id="element-268">
                  Art direction, photography, and motion design.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-269" />
    </div>;
}